import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { Link } from 'react-router-dom';
import blogPosts from '../data/blogPosts';
import './Blog.css';
import { appStoreUrl } from '../lib/appStore';

function Blog() {
  return (
    <div className="page-container blog-container">
      <Helmet>
        <title>Parenting Tips Blog — Better Parent Everyday</title>
        <meta name="description" content="Science-backed parenting articles on sleep, discipline, child development, screen time, and more. Evidence-based tips from Better Parent Everyday." />
        <link rel="canonical" href="https://www.betterparenteveryday.com/blog" />
        <meta property="og:title" content="Parenting Tips Blog — Better Parent Everyday" />
        <meta property="og:description" content="Science-backed parenting articles on sleep, discipline, child development, screen time, and more." />
        <meta property="og:url" content="https://www.betterparenteveryday.com/blog" />
      </Helmet>

      <header className="blog-header">
        <h1>Parenting Tips & Guides</h1>
        <p className="blog-header-subtitle">
          Evidence-based articles to help you grow 1% better every day as a parent.
        </p>
      </header>

      <section className="blog-grid" aria-label="Blog articles">
        {blogPosts.map((post) => (
          <article key={post.slug} className="blog-card">
            <div className="blog-card-content">
              <div className="blog-card-meta">
                <span className="blog-card-category">{post.category}</span>
                <span className="blog-card-date">
                  {new Date(post.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </span>
              </div>
              <h2 className="blog-card-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p className="blog-card-description">{post.description}</p>
              <div className="blog-card-footer">
                <span className="blog-card-read-time">{post.readTime}</span>
                <Link to={`/blog/${post.slug}`} className="blog-card-link">
                  Read article
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          </article>
        ))}
      </section>

      <section className="blog-cta" aria-label="Download app">
        <div className="blog-cta-inner">
          <h2>Get daily parenting tips in your pocket</h2>
          <p>
            These articles are just the beginning. The Better Parent Everyday app delivers
            personalized, science-backed tips every day — in just 5 minutes.
          </p>
          <a
            href={appStoreUrl('website_blog')}
            className="blog-cta-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download free on the App Store
          </a>
        </div>
      </section>
    </div>
  );
}

export default Blog;
